/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-05T12:00:00+05:00
Intent: Remember which session sent the browser to Stripe, so /payment/success only confirms a payment for the account that started it.
*/

import { MS_TOKEN_KEY } from 'src/app/constants/micro-api.service';

export const CHECKOUT_OWNER_KEY = 'checkout_owner';

/** Short, non-reversible fingerprint of the gateway token — the token itself is not copied. */
export function sessionFingerprint(token: string | null | undefined): string | null {
  if (!token) return null;
  let hash = 5381;
  for (let i = 0; i < token.length; i++) {
    hash = ((hash << 5) + hash + token.charCodeAt(i)) | 0;
  }
  return `${token.length}.${(hash >>> 0).toString(36)}`;
}

/** Mark the current session as the one paying, then go to the checkout page. */
export function startCheckout(url: string): void {
  const owner = sessionFingerprint(localStorage.getItem(MS_TOKEN_KEY));
  if (owner) {
    localStorage.setItem(CHECKOUT_OWNER_KEY, owner);
  } else {
    localStorage.removeItem(CHECKOUT_OWNER_KEY);
  }
  window.location.href = url;
}

/**
 * True when the session signed in now is the one that started the checkout. A payment link
 * opened from an email (admin-created online client) has no marker, and a browser that has since
 * signed in to another account has a different one — in both cases the signed-in session is not
 * the payer and must not be used to confirm or open the dashboard.
 */
export function isCheckoutOwner(): boolean {
  const owner = localStorage.getItem(CHECKOUT_OWNER_KEY);
  return !!owner && owner === sessionFingerprint(localStorage.getItem(MS_TOKEN_KEY));
}

export function clearCheckoutOwner(): void {
  localStorage.removeItem(CHECKOUT_OWNER_KEY);
}
